import {Component} from 'react'
import {Redirect} from 'react-router-dom'
import Cookies from 'js-cookie'

import {
  LoginBgContainer,
  FormContainer,
  InputContainer,
  LoginLogoImage,
  LabelInput,
  UserInput,
  CheckboxContainer,
  CheckboxInput,
  ShowPasswordLabel,
  LoginButton,
  SubmitError,
} from './styledComponents'

class Login extends Component {
  state = {
    username: '',
    password: '',
    showPassword: false,
    showSubmitError: false,
    errorMsg: '',
  }

  onChangeUsername = event => {
    this.setState({username: event.target.value})
  }

  onChangePassword = event => {
    this.setState({password: event.target.value})
  }

  onClickShowPassword = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword,
    }))
  }

  renderUsernameField = () => {
    const {username} = this.state
    return (
      <>
        <LabelInput htmlFor="username">USERNAME</LabelInput>
        <UserInput
          type="text"
          id="username"
          value={username}
          onChange={this.onChangeUsername}
          placeholder="Username: rahul"
        />
      </>
    )
  }

  renderPasswordField = () => {
    const {showPassword, password} = this.state
    const passwordType = showPassword ? 'text' : 'password'
    return (
      <>
        <LabelInput htmlFor="password">PASSWORD</LabelInput>
        <UserInput
          type={passwordType}
          id="password"
          value={password}
          onChange={this.onChangePassword}
          placeholder="Password: rahul@2021"
        />
        <CheckboxContainer>
          <CheckboxInput
            type="checkbox"
            id="checkbox"
            onChange={this.onClickShowPassword}
          />
          <ShowPasswordLabel htmlFor="checkbox">
            Show Password
          </ShowPasswordLabel>
        </CheckboxContainer>
      </>
    )
  }

  onSubmitSuccess = jwtToken => {
    const {history} = this.props
    Cookies.set('jwt_token', jwtToken, {expires: 30})
    history.replace('/')
  }

  onSubmitError = errorMsg => {
    this.setState({showSubmitError: true, errorMsg})
  }

  OnSubmitForm = async event => {
    event.preventDefault()
    const {username, password} = this.state
    const userDetails = {username, password}
    const LoginUrl = 'https://apis.ccbp.in/login'
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const response = await fetch(LoginUrl, options)
    const data = await response.json()
    if (response.ok === true) {
      this.onSubmitSuccess(data.jwt_token)
    } else {
      this.onSubmitError(data.error_msg)
    }
  }

  render() {
    const {showSubmitError, errorMsg} = this.state
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }
    return (
      <LoginBgContainer>
        <FormContainer onSubmit={this.OnSubmitForm}>
          <LoginLogoImage
            src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
            alt="website logo"
          />
          <InputContainer>{this.renderUsernameField()}</InputContainer>
          <InputContainer>{this.renderPasswordField()}</InputContainer>
          <LoginButton type="submit">Login</LoginButton>
          {showSubmitError && <SubmitError>*{errorMsg}</SubmitError>}
        </FormContainer>
      </LoginBgContainer>
    )
  }
}

export default Login
